import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {Router} from "../../../stem-core/src/ui/Router";
import {PaymentMethodStore} from "../../State";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {encryptJSON} from "../../../client/crypto/encryptJSON";
import {authService} from "../../../client/connection/services/AuthService";


export const CARD_SECTION_STATE = {
    chooseCard: "chooseCard",
    payWithAddedCard: "payWithAddedCard",
    usingCard: "usingCard",
    addCard: "addCard",
};

export class PaymentMethodController extends Dispatcher {
    cardSectionState = null;
    initialPaymentMethod = null;
    selectedPaymentMethod = null;
    showSaveCardCheckbox = false;
    entry = null;
    savePaymentMethod = true;
    getPayWithAddedCardButtonLabel = NOOP_FUNCTION;
    getChooseCardButtonLabel = NOOP_FUNCTION;
    onSelectSuccess = NOOP_FUNCTION;
    getScope = NOOP_FUNCTION;

    async extractPaymentMethodFields() {
        if (iFrameMerchantService.isCDSPaymentMethod()) {
            const {cardNumber, cardExpiry, cardCvv} = (this.selectedPaymentMethod || {});
            return {
                paymentInfo: await encryptJSON({
                    card_number: cardNumber,
                    card_expiry: cardExpiry,
                    card_cvv: cardCvv,
                }, authService.appSettings.blinkPaymentMethodEncryptionPublicKey),
            }
        }
        return {
            preferredPaymentMethodId: this.selectedPaymentMethod?.id,
        }
    }

    constructor() {
        super();
        PaymentMethodStore.addChangeListener(() => {
            if (!this.initialPaymentMethod) {
                this.update({
                    initialPaymentMethod: PaymentMethodStore.getPrimary(),
                    selectedPaymentMethod: PaymentMethodStore.getPrimary(),
                });
            }
        })
    }

    getInitialPaymentMethod() {
        return this.initialPaymentMethod || (iFrameMerchantService.isCDSPaymentMethod() ? null : PaymentMethodStore.getPrimary());
    }

    onSelectCancel() {
        this.selectedPaymentMethod = this.initialPaymentMethod;
        Router.back();
    };

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }
}

// TODO: If the selected payment method gets deleted, this won't update. Do something about it at some point.
export const paymentMethodController = new PaymentMethodController();
